<template>
    <div class="creationCompetitionOne">
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" label-position="left">
            <el-form-item label="竞赛名称" prop="name">
                <el-input style="width: 500px;" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="竞赛介绍">
                <el-input type="textarea" :rows="4" style="width: 500px;" v-model="form.introduce"></el-input>
            </el-form-item>
            <el-form-item label="行业分类" prop="industryClassify">
                <el-select v-model="form.industryClassify" placeholder="请选择行业分类" style="width: 500px;">
                    <el-option v-for="(item,index) in industryList" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="startTime">
                <el-date-picker
                        v-model="form.startTime"
                        @change="selectStartTime"
                        :picker-options="pickerOptions"
                        type="datetime"
                        value-format="timestamp"
                        placeholder="选择开始日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="overTime">
                <el-date-picker
                        v-model="form.overTime"
                        @change="selectOverTime"
                        :picker-options="pickerOptions"
                        type="datetime"
                        value-format="timestamp"
                        placeholder="选择结束日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="班级" prop="teamClassify">
                <el-select v-model="form.teamClassify" @change="classChanged" placeholder="请选择班级" style="width: 500px;">
                    <el-option v-for="(item,index) in teamList" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="参赛模式">
                <el-radio-group v-model="form.competitionMode">
                    <el-radio :label="1">个人竞赛</el-radio>
                    <el-radio :label="2">团队竞赛</el-radio>
                </el-radio-group>
                <div class="mode-tip">团队人数不固定；允许多人协作、自由选择步骤，队长统一提交。客服由首个成功开始考试的成员作答，其他成员可查看商品、协作编辑快捷回复。</div>
            </el-form-item>
            <el-form-item label="团队编组" v-if="form.competitionMode === 2">
                <div class="team-card" v-for="(team, index) in form.teams" :key="index">
                    <div class="team-card-head">
                        <el-input v-model.trim="team.name" :placeholder="`团队${index + 1}名称`" style="width: 220px"></el-input>
                        <el-button type="text" class="danger" @click="removeTeam(index)">删除团队</el-button>
                    </div>
                    <el-select v-model="team.captain_id" placeholder="选择队长" style="width: 220px; margin-right: 12px" @change="captainChanged(team)">
                        <el-option v-for="student in availableStudents(team)" :key="student.id" :label="student.name || student.username" :value="student.id"></el-option>
                    </el-select>
                    <el-select v-model="team.member_ids" multiple collapse-tags placeholder="选择全部团队成员" style="width: 420px" @change="membersChanged(team)">
                        <el-option v-for="student in availableStudents(team)" :key="student.id" :label="`${student.name || student.username}（${student.username}）`" :value="student.id" :disabled="Number(team.captain_id) === Number(student.id)"></el-option>
                    </el-select>
                </div>
                <el-button type="primary" plain icon="el-icon-plus" @click="addTeam">添加团队</el-button>
                <div class="mode-tip">当前班级每名学生必须且只能加入一个团队，队长也需要包含在成员中。</div>
            </el-form-item>
        </el-form>
        <div class="upDownBtn">
            <el-button @click="toBack">上一步</el-button>
            <el-button @click="toNext" style="background: #1122D8;border-color:#1122D8;color: #ffffff;margin-left: 20px">下一步</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "creationCompetitionOne",
        data(){
            return {
                form:{
                    name:'',
                    introduce:'',
                    industryClassify:'',
                    startTime:'',
                    overTime:'',
                    teamClassify:'',
                    competitionMode: 1,
                    teams: []
                },
                editForm:{},
                industryList:[],
                teamList:[],
                studentList: [],
                classId: null,
                pickerOptions:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 3600 * 1000 * 24;
                    }
                },
                rules:{
                    name: [
                        { required: true, message: '请输入竞赛名称', trigger: 'blur' },
                        { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
                    ],
                    industryClassify: [
                        { required: true, message: '请选择行业分类', trigger: 'change' }
                    ],
                    startTime: [
                        { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                    ],
                    overTime: [
                        { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
                    ],
                    teamClassify: [
                        { required: true, message: '请选择队伍', trigger: 'change' }
                    ]
                }
            }
        },
        created(){
            //编辑
            if (this.$route.query.editRes) {
                this.getEditData(this.$route.query.editRes).then((res) => {
                    this.classId = res.c_id;
                    this.getClassesList();
                    this.getClassStudents();
                });
            }
            this.getCategoryList();
        },
        methods: {
            getEditData(id){
                let _this = this;
                return new Promise(function(resolve, reject) {
                    _this.$http.axiosGetBy(_this.$api.getCom, {com_id:id},res=>{
                        if(res.code === 200){
                            _this.editForm = res.data;
                            resolve(res.data);
                            let date1 = new Date(res.data.begin_time);
                            let date2 = new Date(res.data.end_time);
                            let time1 = date1.getTime();
                            let time2 = date2.getTime();
                            _this.form.name = res.data.name;
                            _this.form.industryClassify = res.data.category_id;
                            _this.form.startTime = time1;
                            _this.form.overTime = time2;
                            _this.form.teamClassify = res.data.c_id;
                            _this.form.competitionMode = Number(res.data.competition_mode) || 1;
                            _this.form.teams = (res.data.teams || []).map(item => ({
                                name: item.name,
                                captain_id: Number(item.captain_id),
                                member_ids: (item.member_ids || []).map(Number)
                            }));
                            if(res.data.introduce){
                                _this.form.introduce = res.data.introduce
                            }
                        } else {
                            _this.$message.warning(res.msg)
                            reject(new Error(`${res.msg}`));
                        }
                    })

                });

            },
            //行业分类
            getCategoryList(){
                this.$http.axiosGetBy(this.$api.categoryList, {}, res=>{
                    if(res.code === 200){
                        this.industryList = res.data
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            },
            //队伍
            getClassesList(){
                let param = {
                    begin_time: this.form.startTime/1000,
                    end_time: this.form.overTime/1000
                };
                if (this.classId) {
                    param.class_id = this.classId;
                }
                this.$http.axiosGetBy(this.$api.classes, param, res=>{
                    if(res.code === 200){
                        this.teamList = res.data
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            },
            classChanged() {
                this.form.teams = [];
                this.getClassStudents();
            },
            getClassStudents() {
                if (!this.form.teamClassify) return;
                this.$http.axiosGetBy(this.$api.studentAdminList, {class_id: this.form.teamClassify}, res => {
                    if (res.code === 200) {
                        const data = res.data && res.data.data ? res.data.data : (res.data || []);
                        this.studentList = data.map(item => ({...item, id: Number(item.id)}));
                    } else {
                        this.$message.warning(res.msg);
                    }
                });
            },
            addTeam() {
                this.form.teams.push({name: `团队${this.form.teams.length + 1}`, captain_id: '', member_ids: []});
            },
            removeTeam(index) {
                this.form.teams.splice(index, 1);
            },
            availableStudents(team) {
                const assignedByOtherTeams = new Set();
                this.form.teams.forEach(item => {
                    if (item === team) return;
                    (item.member_ids || []).forEach(id => assignedByOtherTeams.add(Number(id)));
                    if (item.captain_id) assignedByOtherTeams.add(Number(item.captain_id));
                });
                return this.studentList.filter(student => !assignedByOtherTeams.has(Number(student.id)));
            },
            captainChanged(team) {
                const captainId = Number(team.captain_id);
                const memberIds = (team.member_ids || []).map(Number);
                if (captainId && !memberIds.includes(captainId)) {
                    this.$set(team, 'member_ids', [...memberIds, captainId]);
                }
            },
            membersChanged(team) {
                const assignedByOtherTeams = new Set();
                this.form.teams.forEach(item => {
                    if (item === team) return;
                    (item.member_ids || []).forEach(id => assignedByOtherTeams.add(Number(id)));
                    if (item.captain_id) assignedByOtherTeams.add(Number(item.captain_id));
                });

                const selected = (team.member_ids || []).map(Number);
                const available = selected.filter(id => !assignedByOtherTeams.has(id));
                if (available.length !== selected.length) {
                    this.$message.warning('该学生已加入其他团队');
                }

                const captainId = Number(team.captain_id);
                if (captainId && !available.includes(captainId)) {
                    available.push(captainId);
                    this.$message.warning('队长不能从团队成员中移除，请先更换队长');
                }
                this.$set(team, 'member_ids', Array.from(new Set(available)));
            },
            validateTeams() {
                if (this.form.competitionMode !== 2) return true;
                if (!this.form.teams.length) {
                    this.$message.warning('请至少添加一个团队');
                    return false;
                }
                const assigned = [];
                for (const team of this.form.teams) {
                    if (!team.name || !team.captain_id || team.member_ids.length < 2) {
                        this.$message.warning('每个团队都需要填写名称，并至少配置队长和一名成员');
                        return false;
                    }
                    if (!team.member_ids.map(Number).includes(Number(team.captain_id))) {
                        this.$message.warning(`${team.name}的队长必须保留在团队成员中`);
                        return false;
                    }
                    assigned.push(...team.member_ids);
                }
                const unique = new Set(assigned);
                if (unique.size !== assigned.length) {
                    this.$message.warning('同一名学生不能加入多个团队');
                    return false;
                }
                if (unique.size !== this.studentList.length) {
                    this.$message.warning('请为当前班级的每名学生分配团队');
                    return false;
                }
                return true;
            },
            // 选择开始时间
            selectStartTime(val){
            },
            selectOverTime(val){
                if(!this.form.startTime){
                    this.$message.warning('请先选择开始时间！');
                    this.form.overTime = ''
                } else {
                    if(this.form.overTime < this.form.startTime){
                        this.$message.warning('请选择开始时间之后的日期！');
                        this.form.overTime = ''
                    } else {
                        this.getClassesList()
                    }
                }
            },
            toBack(){
                this.$router.push({
                    path:'/schooladmin/competition'
                })
            },
            toNext(){
                if(this.form.name && this.form.industryClassify && this.form.startTime && this.form.overTime && this.form.teamClassify){
                    if (!this.validateTeams()) return;
                    let formParam = JSON.stringify(this.form);
                    if(this.$route.query.editRes){
                        let editForm = JSON.stringify(this.editForm);
                        this.$router.push({
                            path:'/schooladmin/competition/creationcompetitiontwo',
                            query:{
                                res:formParam,
                                editForm:editForm,
                                editRes:this.$route.query.editRes
                            }
                        })
                    } else {
                        this.$router.push({
                            path:'/schooladmin/competition/creationcompetitiontwo',
                            query:{
                                res:formParam,
                            }
                        })
                    }
                } else {
                    this.$message.warning('必填项不能为空！')
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .creationCompetitionOne{
        padding:40px 0 70px 120px;
    }
    .upDownBtn{
        padding-left: 80px;
    }
    .mode-tip { color: #909399; font-size: 12px; line-height: 22px; }
    .team-card { width: 680px; padding: 14px; margin-bottom: 12px; border: 1px solid #ebeef5; border-radius: 4px; }
    .team-card-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
    .danger { color: #f56c6c; }
</style>
